export const MEE_SCAN_URL = 'https://meescan.biconomy.io/';
